"use strict";var _interopRequireWildcard = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireWildcard");var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _routers = _interopRequireDefault(require("@/router/routers"));
var _user2 = require("@/utils/user");
var _jsCookie = _interopRequireDefault(require("js-cookie"));

var state = {
  token: (0, _auth.getToken)(),
  name: _jsCookie.default.get('name') || '',
  avatar: _jsCookie.default.get('avatar') || '',
  introduction: '',
  roles: [],
  addRouters: [],
  routers: [],
  routerLoadSuccess: false,
  permissions: [],
  permissionLoadSuccess: false };


var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
    _jsCookie.default.set('name', name);
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
    _jsCookie.default.set('avatar', avatar);
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  // 路由
  SET_ROUTERS: function SET_ROUTERS(state, routers) {
    state.addRouters = routers;
    state.routers = _router.constantRoutes.concat(routers);
    var notFound = { path: '*', redirect: '/404', hidden: true };
    state.addRouters.push(notFound);
    state.routers.push(notFound);
    // router.options.routes = state.routers
    _router.default.addRoutes(state.addRouters);
    // console.log(router.getAllRoutes())
    state.routerLoadSuccess = true;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
    // 权限加载成功标识
    state.permissionLoadSuccess = true;
  } };


var actions = {
  // user login
  login: function login(_ref, userInfo) {var commit = _ref.commit;var
    username = userInfo.username,password = userInfo.password;
    return new Promise(function (resolve, reject) {
      (0, _user.login)({ username: username.trim(), password: password }).then(function (response) {
        // const { data } = response
        commit('SET_TOKEN', username);
        commit('SET_NAME', username);
        (0, _auth.setToken)(username); // , { expires: 1 * 10 }3600 * 24
        commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif');
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // 获取路由
  getRouters: function getRouters(_ref2) {var _this = this;var commit = _ref2.commit,dispatch = _ref2.dispatch;
    return new Promise( /*#__PURE__*/function () {var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.prev = 0;if (


                _this.permissionLoadSuccess) {_context.next = 4;break;}_context.next = 4;return (
                  dispatch('getPermissions'));case 4:_context.next = 9;break;case 6:_context.prev = 6;_context.t0 = _context["catch"](0);


                reject(_context.t0);case 9:

                (0, _user.getMenuList)().then(function (response) {var
                  data = response.data;
                  if (!data) {
                    console.log('获取菜单列表数据失败');
                    Promise.reject('获取菜单列表数据失败');
                  }
                  var menus = (0, _user2.getRouters)((0, _user2.getMenus)(data), _routers.default);

                  commit('SET_ROUTERS', menus);
                  //
                  // commit('SET_NAME', state.name ? state.name : 'admin')
                  // commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
                  resolve(data);
                }).catch(function (error) {
                  console.log(error);
                  Promise.reject(error);
                });case 10:case "end":return _context.stop();}}}, _callee, null, [[0, 6]]);}));return function (_x, _x2) {return _ref3.apply(this, arguments);};}());

  },

  // 获取权限集合并存储到store中
  getPermissions: function getPermissions(_ref4) {var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.getButtonPermissions)().then(function (response) {var
        data = response.data;
        if (!data) {
          reject('获取按钮权限数据失败');
        }
        var permissions = [];
        (0, _user2.convertPermissions)(data, permissions);
        commit('SET_PERMISSIONS', permissions);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // get user info
  getInfo: function getInfo(_ref5) {var commit = _ref5.commit,state = _ref5.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (response) {var
        data = response.data;

        if (!data) {
          reject('Verification failed, please Login again.');
        }var

        roles = data.roles,name = data.name,avatar = data.avatar,introduction = data.introduction;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }

        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // user logout
  logout: function logout(_ref6) {var commit = _ref6.commit,state = _ref6.state,dispatch = _ref6.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true });

        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  // remove token
  resetToken: function resetToken(_ref7) {var commit = _ref7.commit;
    return new Promise(function (resolve) {
      console.log('resetToken');
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },

  // dynamically modify permissions
  changeRoles: function changeRoles(_ref8, role) {var commit = _ref8.commit,dispatch = _ref8.dispatch;
    return new Promise( /*#__PURE__*/function () {var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {var token, _ref10, roles, accessRoutes;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                token = role + '-token';

                commit('SET_TOKEN', token);
                (0, _auth.setToken)(token);_context2.next = 5;return (

                  dispatch('getInfo'));case 5:_ref10 = _context2.sent;roles = _ref10.roles;

                (0, _router.resetRouter)();

                // generate accessible routes map based on roles
                _context2.next = 10;return dispatch('permission/generateRoutes', roles, { root: true });case 10:accessRoutes = _context2.sent;

                // dynamically add accessible routes
                _router.default.addRoutes(accessRoutes);

                // reset visited views and cached views
                dispatch('tagsView/delAllViews', null, { root: true });

                resolve();case 14:case "end":return _context2.stop();}}}, _callee2);}));return function (_x3) {return _ref9.apply(this, arguments);};}());

  } };var _default =


{
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions };exports.default = _default;